// Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Cybs
import InlineAlert from './component/inline';
import ToastAlert from './component/toast';

const CybsAlert = ({
  i18n: i18nProp,
  dataTest,
  isInline,
  status,
  ...props
}) => {
  const getAlertType = () => {
    const alertType = {
      positive: 'success',
      success: 'success',
      negative: 'error',
      error: 'error',
      warning: 'warning',
      information: 'info',
      neutral: 'info'
    };
    return alertType[status];
  };

  const alertType = getAlertType();

  const i18n = { ...CybsAlert.defaultProps.i18n, ...i18nProp };

  return isInline ? (
    <InlineAlert
      i18n={i18n}
      dataTest={dataTest}
      status={alertType}
      {...props}
    />
  ) : (
    <ToastAlert i18n={i18n} dataTest={dataTest} status={alertType} {...props} />
  );
};

CybsAlert.propTypes = {
  /**
   * Data Test.
   */
  dataTest: PropTypes.string.isRequired,

  /**
   * Localization dictionary
   */
  i18n: PropTypes.shape({
    /**
     * Aria Label for the close button.
     * */
    ariaLabel: PropTypes.string,
    /**
     * Prefix to status message (e.g. 'Error')
     */
    iconTitle: PropTypes.string,
    /**
     * Message to display as the status.
     */
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    /**
     * Title to display in the alert
     */
    title: PropTypes.string
  }),

  /**
   * If `true`, the alert will be relative to its parent.
   */
  isInline: PropTypes.bool,

  /**
   * Status type for the alert.
   */
  status: PropTypes.oneOf([
    'error',
    'info',
    'information',
    'negative',
    'neutral',
    'positive',
    'success',
    'warning'
  ])
};

CybsAlert.defaultProps = {
  i18n: {
    ariaLabel: 'Close alert',
    iconTitle: '',
    message: '',
    title: ''
  },
  isInline: false,
  status: 'information'
};

CybsAlert.displayName = 'CybsAlert';

export default CybsAlert;
